import _ from 'lodash';
import { psAxios } from '@patsnap/common-ps-http';
import { UserCenterService } from '@patsnap-utils/biz';
import { Message, injectService } from '@patsnap/tahiti-core';
import { freeViewRequestSignInterceptor, freeViewRequestSuccessInterceptor } from 'library-@/utils/patent-view-free-judgment-util.js';
import { getI18nInstance } from '@/locales/i18nInstance.js';

const NO_PERMISSION_HTTP_ERROR_CODE = 403;
const OVER_LIMIT_HTTP_ERROR_CODE = 429;

export function injectFreeViewInterceptor(locale: string) {
    const message = injectService<Message>(Message);

    psAxios.interceptors.request.use(freeViewRequestSuccessInterceptor);

    psAxios.interceptors.request.use(freeViewRequestSignInterceptor);

    psAxios.interceptors.request.use(config => {
        if (config.headers) config.headers['X-Site-Lang'] = _.upperCase(locale);
        return config;
    });

    const { logoutHref } = new UserCenterService();
    psAxios.interceptors.response.use(undefined, error => {
        const httpErrorCode = _.get(error, 'response.status');

        if (httpErrorCode === NO_PERMISSION_HTTP_ERROR_CODE) {
            window.location.href = `${logoutHref}&errcode=39999&errorType=a4`;
            return error;
        }

        if (httpErrorCode === OVER_LIMIT_HTTP_ERROR_CODE) {
            const i18n = getI18nInstance();
            message.warning({
                message: i18n.t('freeLimit'),
                showClose: true,
            });
        }

        return error;
    });
}
